export const formatDateMsDsYHI = (date: Date | string | number) => {
  const d = new Date(date);
  const month = d.getMonth() > 8 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`;
  const day = d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`;
  const min = d.getMinutes() > 9 ? d.getMinutes() : `0${d.getMinutes()}`;
  const hour = d.getHours() > 9 ? d.getHours() : `0${d.getHours()}`;
  return `${month}/${day}/${d.getFullYear()} ${hour}:${min}`;
};
